export default __webpack_public_path__ + "static/media/mazuma2.03dd7c9b.jpg";